import {
  AcompanhamentoCondicaoSaudeTematicaEnum,
  BuscaCidadaoListagemDesenvolvimentoInfantilQuery,
  BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables,
  BuscaCidadaoListagemDiabetesQuery,
  BuscaCidadaoListagemDiabetesQueryVariables,
  BuscaCidadaoListagemGeralQuery,
  BuscaCidadaoListagemGeralQueryVariables,
  BuscaCidadaoListagemGestantePuerperaQuery,
  BuscaCidadaoListagemGestantePuerperaQueryVariables,
  BuscaCidadaoListagemHipertensaoQuery,
  BuscaCidadaoListagemHipertensaoQueryVariables,
  BuscaCidadaoListagemPessoaIdosaQuery,
  BuscaCidadaoListagemPessoaIdosaQueryVariables,
  BuscaCidadaoListagemSaudeBucalQuery,
  BuscaCidadaoListagemSaudeBucalQueryVariables,
  BuscaCidadaoListagemTematicaSaudeMulherQuery,
  BuscaCidadaoListagemTematicaSaudeMulherQueryVariables,
  GrupoImunobiologicoEnum,
} from 'graphql/types.generated'
import { ReactComponent as IconSaudeMulher } from 'images/acompanhamento/icon-saude-mulher.svg'
import { PecIconProps } from 'view/atendimentos/list/PecIcon'

type CidadaoListagemDiabetesQueryResult = BuscaCidadaoListagemDiabetesQuery['acompanhamentoCondicaoSaude']
type CidadaoListagemPessoaIdosaQueryResult = BuscaCidadaoListagemPessoaIdosaQuery['acompanhamentoCondicaoSaude']
type CidadaoListagemHipertensaoQueryResult = BuscaCidadaoListagemHipertensaoQuery['acompanhamentoCondicaoSaude']
type CidadaoListagemSaudeBucalQueryResult = BuscaCidadaoListagemSaudeBucalQuery['acompanhamentoCondicaoSaude']

export type CidadaoListagemDiabetesQueryModel = CidadaoListagemDiabetesQueryResult['content'][0]
export type CidadaoListagemPessoaIdosaQueryModel = CidadaoListagemPessoaIdosaQueryResult['content'][0]
export type CidadaoListagemHipertensaoQueryModel = CidadaoListagemHipertensaoQueryResult['content'][0]
export type CidadaoListagemSaudeBucalQueryModel = CidadaoListagemSaudeBucalQueryResult['content'][0]

export type BuscaCidadaoQuery =
  | BuscaCidadaoListagemGeralQuery
  | BuscaCidadaoListagemGestantePuerperaQuery
  | BuscaCidadaoListagemHipertensaoQuery
  | BuscaCidadaoListagemDiabetesQuery
  | BuscaCidadaoListagemPessoaIdosaQuery
  | BuscaCidadaoListagemDesenvolvimentoInfantilQuery
  | BuscaCidadaoListagemSaudeBucalQuery
  | BuscaCidadaoListagemTematicaSaudeMulherQuery

export type BuscaCidadaoQueryResult = BuscaCidadaoQuery['acompanhamentoCondicaoSaude']
export type BuscaCidadaoQueryResultModel = BuscaCidadaoQueryResult['content'][0]

export type BuscaCidadaoQueryVariables =
  | BuscaCidadaoListagemGestantePuerperaQueryVariables
  | BuscaCidadaoListagemGeralQueryVariables
  | BuscaCidadaoListagemHipertensaoQueryVariables
  | BuscaCidadaoListagemDiabetesQueryVariables
  | BuscaCidadaoListagemPessoaIdosaQueryVariables
  | BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables
  | BuscaCidadaoListagemSaudeBucalQueryVariables
  | BuscaCidadaoListagemTematicaSaudeMulherQueryVariables

export interface ListaTematicaModel {
  titulo: string
  icone: PecIconProps['icon']
}

export const listaTematicaRecord: Record<AcompanhamentoCondicaoSaudeTematicaEnum, ListaTematicaModel> = {
  [AcompanhamentoCondicaoSaudeTematicaEnum.GERAL]: { titulo: 'Geral', icone: 'userFilled' },
  [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]: {
    titulo: 'Gestação e puerpério',
    icone: 'pregnant',
  },
  [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]: { titulo: 'Pessoa idosa', icone: 'sixtyPlus' },
  [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]: {
    titulo: 'Desenvolvimento infantil',
    icone: 'teddyBear',
  },
  [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]: { titulo: 'Diabetes', icone: 'glucometer' },
  [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]: {
    titulo: 'Hipertensão',
    icone: 'bloodPressureFilled',
  },
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]: { titulo: 'Saúde da mulher', icone: IconSaudeMulher },
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]: { titulo: 'Saúde bucal', icone: 'toothFilled' },
}

export const listaTematicaEntries = Object.entries(listaTematicaRecord) as [
  AcompanhamentoCondicaoSaudeTematicaEnum,
  ListaTematicaModel
][]

export const criterioInclusaoByTematica: Record<AcompanhamentoCondicaoSaudeTematicaEnum, string> = {
  [AcompanhamentoCondicaoSaudeTematicaEnum.GERAL]:
    'Lista-base da qual todas as demais listas temáticas derivam. Apresenta todas as pessoas com vínculo a alguma equipe, considerando-se válido apenas o vínculo mais recente registrado - mesmo que a pessoa tenha tido vínculos anteriores com outras equipes. Toda pessoa que aparece em uma lista temática também aparece na lista Geral; porém, nem toda pessoa da lista Geral aparece nas listas temáticas específicas, pois estas aplicam critérios adicionais (idade, condição de saúde, etc.).',
  [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]:
    'Apresenta pessoas com gestação ativa registrada no Prontuário, ou cuja gestação foi encerrada há até 42 dias em relação à data atual (período de puerpério).',
  [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]:
    'Apresenta pessoas com 60 anos ou mais, considerando a idade na data atual.',
  [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]:
    'Apresenta pessoas com menos de 5 anos completos (0 a 4 anos), considerando a idade na data atual.',
  [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]:
    'Apresenta pessoas com diagnóstico de alguma condição de diabetes ativa no Prontuário. É possível utilizar o filtro "Não incluídos na lista de problemas e condições" para incluir pessoas que já tiveram diagnóstico de diabetes em algum momento, mas que atualmente não possuem nenhuma condição relacionada ativa no Prontuário.',
  [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]:
    'Apresenta pessoas com diagnóstico de alguma condição de hipertensão ativa no Prontuário. É possível utilizar o filtro "Não incluídos na lista de problemas e condições" para incluir pessoas que já tiveram diagnóstico de hipertensão em algum momento, mas que atualmente não possuem nenhuma condição relacionada ativa no Prontuário.',
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]:
    'Apresenta, por padrão, pessoas com sexo definido como Feminino ou Indeterminado, entre 14 e 69 anos. Pessoas com identidade de gênero registrada como "Mulher transgênero" não são incluídas nesta lista, mesmo com sexo definido como Feminino - esse critério não pode ser alterado pelo usuário. Por meio dos critérios de seleção, é possível optar por incluir também pessoas com sexo definido como Masculino, desde que a identidade de gênero registrada seja "Homem transgênero".',
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]:
    'Apresenta, dentre as pessoas que atendem ao filtro padrão de período (último atendimento individual nos últimos 3 anos), aquelas que possuem ao menos um atendimento odontológico individual registrado no Prontuário. O filtro de período considera o atendimento individual de forma geral, e não especificamente o atendimento odontológico',
}

export const grupoImunobiologicoLabel: Record<GrupoImunobiologicoEnum, string> = {
  DIFTERIA_TETANO_PERTUSIS_HEPATITE_B_HAEMOPHILUS_INFLUENZA_B:
    'Difteria, Tétano, Pertusis, Hepatite B, Haemophilus Influenza B',
  POLIOMELITE: 'Poliomielite',
  SARAMPO_CACHUMBA_RUBEOLA: 'Sarampo, Caxumba, Rubéola',
  PNEUMOCOCICA: 'Pneumocócica',
  DTPA: 'dTpa',
  INFLUENZA: 'Influenza (últimos 12 meses)',
  HPV: 'HPV',
}
